import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import VidereUndersokelserKomponent from '../components/VidereUndersokelser';
import HelpButton from '../components/HelpButton';
import './Eiendom.css';

function VidereUndersokelserSide() {
  const { eiendomId } = useParams();
  const navigate = useNavigate();
  const [eiendom, setEiendom] = useState(null);
  const [videreUndersokelser, setVidereUndersokelser] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [eiendomId]);

  const fetchData = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'https://takstmann-api.swagner.workers.dev';
      const token = localStorage.getItem('token');

      // Hent eiendom info
      const eiendomResponse = await fetch(`${API_URL}/api/eiendom/${eiendomId}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (eiendomResponse.ok) {
        setEiendom(await eiendomResponse.json());
      }

      // Hent videre undersøkelser
      const undersokelserResponse = await fetch(`${API_URL}/api/eiendom/${eiendomId}/videre-undersokelser`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (undersokelserResponse.ok) {
        setVidereUndersokelser(await undersokelserResponse.json());
      }
    } catch (error) {
      console.error('Feil ved henting av data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Laster...</div>;
  }

  if (!eiendom) {
    return <div className="error">Fant ikke eiendom</div>;
  }

  // Grupper undersøkelser etter bygningsdel
  const undersokelserPerBygningsdel = {};
  const generelleUndersokelser = [];

  videreUndersokelser.forEach(u => {
    if (u.bygningsdel_id) {
      if (!undersokelserPerBygningsdel[u.bygningsdel_id]) {
        undersokelserPerBygningsdel[u.bygningsdel_id] = [];
      }
      undersokelserPerBygningsdel[u.bygningsdel_id].push(u);
    } else {
      generelleUndersokelser.push(u);
    }
  });

  return (
    <div className="eiendom-container">
      <div className="eiendom-header">
        <button onClick={() => navigate(`/eiendom/${eiendomId}`)} className="btn-back">
          ← Tilbake til eiendom
        </button>
        <h1>
          💡 Videre undersøkelser
          <HelpButton title="Hva er videre undersøkelser?" size="medium">
            <p>
              <strong>Videre undersøkelser</strong> er undersøkelser som anbefales gjennomført
              utover det som er dekket i tilstandsrapporten etter NS3600:2018.
            </p>
            <p>Dette kan være:</p>
            <ul>
              <li><strong>Automatiske forslag</strong> - Generert basert på svar i befaringen (f.eks. TGIU, TG2, TG3)</li>
              <li><strong>Generelle undersøkelser</strong> - Radon, asbest, el-kontroll osv. for hele eiendommen</li>
              <li><strong>Bygningsdelspesifikke</strong> - Loft-kontroll, fuktmåling osv. for en spesifikk bygningsdel</li>
            </ul>
            <p>
              <strong>Hvorfor anbefales dette?</strong><br/>
              Tilstandsrapporten er en visuell befaring. Hvis vi ser tegn på skjulte problemer
              (fukt, radon, elektriske feil), anbefaler vi videre undersøkelser for å bekrefte
              omfanget.
            </p>
            <p>
              <strong>Prioritetsnivåer:</strong>
            </p>
            <ul>
              <li>🔴 <strong>Kritisk</strong> - Må gjøres straks, påvirker sikkerhet eller store skader</li>
              <li>🟡 <strong>Anbefalt</strong> - Bør gjøres innen kort tid, kan utvikle seg</li>
              <li>🟢 <strong>Valgfri</strong> - Kan vurderes, men ikke nødvendig umiddelbart</li>
            </ul>
          </HelpButton>
        </h1>
        <p style={{fontSize: '16px', color: '#666'}}>
          {eiendom.adresse} - Oversikt over alle anbefalte videre undersøkelser
        </p>
      </div>

      <div className="hjelp-seksjon" style={{
        backgroundColor: '#f0f7ff',
        border: '2px solid #2196f3',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '30px'
      }}>
        <h3>ℹ️ Hva er "Videre undersøkelser"?</h3>
        <p>
          Videre undersøkelser er undersøkelser som anbefales gjennomført utover det som er dekket
          i tilstandsrapporten. Dette kan være:
        </p>
        <ul>
          <li><strong>Automatiske forslag</strong> - Generert basert på svar i befaringen (f.eks. TGIU, TG2, TG3)</li>
          <li><strong>Generelle undersøkelser</strong> - Radon, asbest, el-kontroll osv. for hele eiendommen</li>
          <li><strong>Bygningsdelspesifikke</strong> - Loft-kontroll, fuktmåling osv. for en spesifikk bygningsdel</li>
        </ul>
        <p>
          <strong>Merk:</strong> Disse vises samlet i rapporten som anbefalinger til kjøper/selger.
        </p>
      </div>

      {/* Generelle undersøkelser (ikke knyttet til en spesifikk bygningsdel) */}
      <VidereUndersokelserKomponent
        eiendomId={parseInt(eiendomId)}
        bygningsdelId={null}
        bygningsdelType={null}
        eksisterendeUndersokelser={generelleUndersokelser}
        regelForslag={[]}
        onUndersokelseOpprettet={fetchData}
        onUndersokelseSlettet={fetchData}
      />

      {/* Vis antall totale undersøkelser */}
      {videreUndersokelser.length > 0 && (
        <div style={{
          marginTop: '30px',
          padding: '15px',
          backgroundColor: '#e8f5e9',
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <strong>Totalt {videreUndersokelser.length} videre undersøkelse(r) anbefalt</strong>
        </div>
      )}
    </div>
  );
}

export default VidereUndersokelserSide;
